import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'Index',
      component: ()=> import('@/views/index')
    },
    {
      path: '/club',
      name: 'Club',
      component: ()=> import('@/views/club')
    },
    {
      path: '/star',
      name: 'Star',
      component: ()=> import('@/views/osstar')
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js